export const PRACTICE_ROUNDS_SOLITAIRE_MOCK = [
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'kawaikea',
        opponentScore: 4180,
        secrets: [
          {
            index: 0,
            value: 46,
          },
          {
            index: 1,
            value: 6,
          },
          {
            index: 2,
            value: 16,
          },
          {
            index: 3,
            value: 19,
          },
          {
            index: 4,
            value: 11,
          },
          {
            index: 5,
            value: 36,
          },
          {
            index: 6,
            value: 26,
          },
          {
            index: 7,
            value: 30,
          },
          {
            index: 8,
            value: 0,
          },
          {
            index: 9,
            value: 7,
          },
          {
            index: 10,
            value: 4,
          },
          {
            index: 11,
            value: 14,
          },
          {
            index: 12,
            value: 43,
          },
          {
            index: 13,
            value: 40,
          },
          {
            index: 14,
            value: 22,
          },
          {
            index: 15,
            value: 2,
          },
          {
            index: 16,
            value: 41,
          },
          {
            index: 17,
            value: 51,
          },
          {
            index: 18,
            value: 12,
          },
          {
            index: 19,
            value: 32,
          },
          {
            index: 20,
            value: 47,
          },
          {
            index: 21,
            value: 9,
          },
          {
            index: 22,
            value: 1,
          },
          {
            index: 23,
            value: 49,
          },
          {
            index: 24,
            value: 31,
          },
          {
            index: 25,
            value: 48,
          },
          {
            index: 26,
            value: 35,
          },
          {
            index: 27,
            value: 25,
          },
          {
            index: 28,
            value: 37,
          },
          {
            index: 29,
            value: 15,
          },
          {
            index: 30,
            value: 42,
          },
          {
            index: 31,
            value: 13,
          },
          {
            index: 32,
            value: 44,
          },
          {
            index: 33,
            value: 33,
          },
          {
            index: 34,
            value: 27,
          },
          {
            index: 35,
            value: 28,
          },
          {
            index: 36,
            value: 3,
          },
          {
            index: 37,
            value: 50,
          },
          {
            index: 38,
            value: 8,
          },
          {
            index: 39,
            value: 45,
          },
          {
            index: 40,
            value: 18,
          },
          {
            index: 41,
            value: 21,
          },
          {
            index: 42,
            value: 20,
          },
          {
            index: 43,
            value: 38,
          },
          {
            index: 44,
            value: 17,
          },
          {
            index: 45,
            value: 10,
          },
          {
            index: 46,
            value: 5,
          },
          {
            index: 47,
            value: 34,
          },
          {
            index: 48,
            value: 24,
          },
          {
            index: 49,
            value: 39,
          },
          {
            index: 50,
            value: 29,
          },
          {
            index: 51,
            value: 23,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Katia Ticuta',
        opponentScore: 40,
        secrets: [
          {
            index: 0,
            value: 45,
          },
          {
            index: 1,
            value: 30,
          },
          {
            index: 2,
            value: 31,
          },
          {
            index: 3,
            value: 3,
          },
          {
            index: 4,
            value: 17,
          },
          {
            index: 5,
            value: 16,
          },
          {
            index: 6,
            value: 24,
          },
          {
            index: 7,
            value: 26,
          },
          {
            index: 8,
            value: 20,
          },
          {
            index: 9,
            value: 48,
          },
          {
            index: 10,
            value: 0,
          },
          {
            index: 11,
            value: 15,
          },
          {
            index: 12,
            value: 6,
          },
          {
            index: 13,
            value: 47,
          },
          {
            index: 14,
            value: 10,
          },
          {
            index: 15,
            value: 49,
          },
          {
            index: 16,
            value: 38,
          },
          {
            index: 17,
            value: 27,
          },
          {
            index: 18,
            value: 2,
          },
          {
            index: 19,
            value: 1,
          },
          {
            index: 20,
            value: 34,
          },
          {
            index: 21,
            value: 23,
          },
          {
            index: 22,
            value: 22,
          },
          {
            index: 23,
            value: 9,
          },
          {
            index: 24,
            value: 13,
          },
          {
            index: 25,
            value: 32,
          },
          {
            index: 26,
            value: 4,
          },
          {
            index: 27,
            value: 35,
          },
          {
            index: 28,
            value: 5,
          },
          {
            index: 29,
            value: 21,
          },
          {
            index: 30,
            value: 36,
          },
          {
            index: 31,
            value: 42,
          },
          {
            index: 32,
            value: 43,
          },
          {
            index: 33,
            value: 44,
          },
          {
            index: 34,
            value: 40,
          },
          {
            index: 35,
            value: 39,
          },
          {
            index: 36,
            value: 33,
          },
          {
            index: 37,
            value: 50,
          },
          {
            index: 38,
            value: 28,
          },
          {
            index: 39,
            value: 12,
          },
          {
            index: 40,
            value: 41,
          },
          {
            index: 41,
            value: 14,
          },
          {
            index: 42,
            value: 51,
          },
          {
            index: 43,
            value: 8,
          },
          {
            index: 44,
            value: 19,
          },
          {
            index: 45,
            value: 46,
          },
          {
            index: 46,
            value: 25,
          },
          {
            index: 47,
            value: 18,
          },
          {
            index: 48,
            value: 7,
          },
          {
            index: 49,
            value: 11,
          },
          {
            index: 50,
            value: 29,
          },
          {
            index: 51,
            value: 37,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'zebo',
        opponentScore: 3160,
        secrets: [
          {
            index: 0,
            value: 29,
          },
          {
            index: 1,
            value: 19,
          },
          {
            index: 2,
            value: 10,
          },
          {
            index: 3,
            value: 16,
          },
          {
            index: 4,
            value: 0,
          },
          {
            index: 5,
            value: 50,
          },
          {
            index: 6,
            value: 9,
          },
          {
            index: 7,
            value: 12,
          },
          {
            index: 8,
            value: 2,
          },
          {
            index: 9,
            value: 6,
          },
          {
            index: 10,
            value: 36,
          },
          {
            index: 11,
            value: 25,
          },
          {
            index: 12,
            value: 40,
          },
          {
            index: 13,
            value: 14,
          },
          {
            index: 14,
            value: 13,
          },
          {
            index: 15,
            value: 43,
          },
          {
            index: 16,
            value: 18,
          },
          {
            index: 17,
            value: 17,
          },
          {
            index: 18,
            value: 45,
          },
          {
            index: 19,
            value: 42,
          },
          {
            index: 20,
            value: 1,
          },
          {
            index: 21,
            value: 24,
          },
          {
            index: 22,
            value: 26,
          },
          {
            index: 23,
            value: 15,
          },
          {
            index: 24,
            value: 7,
          },
          {
            index: 25,
            value: 51,
          },
          {
            index: 26,
            value: 22,
          },
          {
            index: 27,
            value: 47,
          },
          {
            index: 28,
            value: 30,
          },
          {
            index: 29,
            value: 27,
          },
          {
            index: 30,
            value: 31,
          },
          {
            index: 31,
            value: 21,
          },
          {
            index: 32,
            value: 48,
          },
          {
            index: 33,
            value: 8,
          },
          {
            index: 34,
            value: 20,
          },
          {
            index: 35,
            value: 44,
          },
          {
            index: 36,
            value: 32,
          },
          {
            index: 37,
            value: 4,
          },
          {
            index: 38,
            value: 23,
          },
          {
            index: 39,
            value: 46,
          },
          {
            index: 40,
            value: 28,
          },
          {
            index: 41,
            value: 33,
          },
          {
            index: 42,
            value: 37,
          },
          {
            index: 43,
            value: 35,
          },
          {
            index: 44,
            value: 38,
          },
          {
            index: 45,
            value: 49,
          },
          {
            index: 46,
            value: 3,
          },
          {
            index: 47,
            value: 34,
          },
          {
            index: 48,
            value: 11,
          },
          {
            index: 49,
            value: 5,
          },
          {
            index: 50,
            value: 41,
          },
          {
            index: 51,
            value: 39,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Ben Millett',
        opponentScore: 3365,
        secrets: [
          {
            index: 0,
            value: 8,
          },
          {
            index: 1,
            value: 46,
          },
          {
            index: 2,
            value: 9,
          },
          {
            index: 3,
            value: 15,
          },
          {
            index: 4,
            value: 39,
          },
          {
            index: 5,
            value: 49,
          },
          {
            index: 6,
            value: 2,
          },
          {
            index: 7,
            value: 0,
          },
          {
            index: 8,
            value: 44,
          },
          {
            index: 9,
            value: 51,
          },
          {
            index: 10,
            value: 26,
          },
          {
            index: 11,
            value: 32,
          },
          {
            index: 12,
            value: 12,
          },
          {
            index: 13,
            value: 16,
          },
          {
            index: 14,
            value: 14,
          },
          {
            index: 15,
            value: 30,
          },
          {
            index: 16,
            value: 6,
          },
          {
            index: 17,
            value: 1,
          },
          {
            index: 18,
            value: 23,
          },
          {
            index: 19,
            value: 27,
          },
          {
            index: 20,
            value: 31,
          },
          {
            index: 21,
            value: 50,
          },
          {
            index: 22,
            value: 17,
          },
          {
            index: 23,
            value: 19,
          },
          {
            index: 24,
            value: 40,
          },
          {
            index: 25,
            value: 41,
          },
          {
            index: 26,
            value: 48,
          },
          {
            index: 27,
            value: 45,
          },
          {
            index: 28,
            value: 13,
          },
          {
            index: 29,
            value: 7,
          },
          {
            index: 30,
            value: 21,
          },
          {
            index: 31,
            value: 29,
          },
          {
            index: 32,
            value: 38,
          },
          {
            index: 33,
            value: 24,
          },
          {
            index: 34,
            value: 28,
          },
          {
            index: 35,
            value: 5,
          },
          {
            index: 36,
            value: 20,
          },
          {
            index: 37,
            value: 10,
          },
          {
            index: 38,
            value: 43,
          },
          {
            index: 39,
            value: 22,
          },
          {
            index: 40,
            value: 18,
          },
          {
            index: 41,
            value: 34,
          },
          {
            index: 42,
            value: 36,
          },
          {
            index: 43,
            value: 47,
          },
          {
            index: 44,
            value: 33,
          },
          {
            index: 45,
            value: 37,
          },
          {
            index: 46,
            value: 35,
          },
          {
            index: 47,
            value: 25,
          },
          {
            index: 48,
            value: 3,
          },
          {
            index: 49,
            value: 42,
          },
          {
            index: 50,
            value: 11,
          },
          {
            index: 51,
            value: 4,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'zebo',
        opponentScore: 3160,
        secrets: [
          {
            index: 0,
            value: 29,
          },
          {
            index: 1,
            value: 19,
          },
          {
            index: 2,
            value: 10,
          },
          {
            index: 3,
            value: 16,
          },
          {
            index: 4,
            value: 0,
          },
          {
            index: 5,
            value: 50,
          },
          {
            index: 6,
            value: 9,
          },
          {
            index: 7,
            value: 12,
          },
          {
            index: 8,
            value: 2,
          },
          {
            index: 9,
            value: 6,
          },
          {
            index: 10,
            value: 36,
          },
          {
            index: 11,
            value: 25,
          },
          {
            index: 12,
            value: 40,
          },
          {
            index: 13,
            value: 14,
          },
          {
            index: 14,
            value: 13,
          },
          {
            index: 15,
            value: 43,
          },
          {
            index: 16,
            value: 18,
          },
          {
            index: 17,
            value: 17,
          },
          {
            index: 18,
            value: 45,
          },
          {
            index: 19,
            value: 42,
          },
          {
            index: 20,
            value: 1,
          },
          {
            index: 21,
            value: 24,
          },
          {
            index: 22,
            value: 26,
          },
          {
            index: 23,
            value: 15,
          },
          {
            index: 24,
            value: 7,
          },
          {
            index: 25,
            value: 51,
          },
          {
            index: 26,
            value: 22,
          },
          {
            index: 27,
            value: 47,
          },
          {
            index: 28,
            value: 30,
          },
          {
            index: 29,
            value: 27,
          },
          {
            index: 30,
            value: 31,
          },
          {
            index: 31,
            value: 21,
          },
          {
            index: 32,
            value: 48,
          },
          {
            index: 33,
            value: 8,
          },
          {
            index: 34,
            value: 20,
          },
          {
            index: 35,
            value: 44,
          },
          {
            index: 36,
            value: 32,
          },
          {
            index: 37,
            value: 4,
          },
          {
            index: 38,
            value: 23,
          },
          {
            index: 39,
            value: 46,
          },
          {
            index: 40,
            value: 28,
          },
          {
            index: 41,
            value: 33,
          },
          {
            index: 42,
            value: 37,
          },
          {
            index: 43,
            value: 35,
          },
          {
            index: 44,
            value: 38,
          },
          {
            index: 45,
            value: 49,
          },
          {
            index: 46,
            value: 3,
          },
          {
            index: 47,
            value: 34,
          },
          {
            index: 48,
            value: 11,
          },
          {
            index: 49,
            value: 5,
          },
          {
            index: 50,
            value: 41,
          },
          {
            index: 51,
            value: 39,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Scott Rhoten',
        opponentScore: 60,
        secrets: [
          {
            index: 0,
            value: 15,
          },
          {
            index: 1,
            value: 32,
          },
          {
            index: 2,
            value: 6,
          },
          {
            index: 3,
            value: 4,
          },
          {
            index: 4,
            value: 38,
          },
          {
            index: 5,
            value: 0,
          },
          {
            index: 6,
            value: 10,
          },
          {
            index: 7,
            value: 9,
          },
          {
            index: 8,
            value: 21,
          },
          {
            index: 9,
            value: 3,
          },
          {
            index: 10,
            value: 5,
          },
          {
            index: 11,
            value: 50,
          },
          {
            index: 12,
            value: 22,
          },
          {
            index: 13,
            value: 12,
          },
          {
            index: 14,
            value: 41,
          },
          {
            index: 15,
            value: 13,
          },
          {
            index: 16,
            value: 25,
          },
          {
            index: 17,
            value: 16,
          },
          {
            index: 18,
            value: 33,
          },
          {
            index: 19,
            value: 18,
          },
          {
            index: 20,
            value: 35,
          },
          {
            index: 21,
            value: 8,
          },
          {
            index: 22,
            value: 51,
          },
          {
            index: 23,
            value: 30,
          },
          {
            index: 24,
            value: 39,
          },
          {
            index: 25,
            value: 47,
          },
          {
            index: 26,
            value: 27,
          },
          {
            index: 27,
            value: 37,
          },
          {
            index: 28,
            value: 23,
          },
          {
            index: 29,
            value: 40,
          },
          {
            index: 30,
            value: 19,
          },
          {
            index: 31,
            value: 48,
          },
          {
            index: 32,
            value: 11,
          },
          {
            index: 33,
            value: 28,
          },
          {
            index: 34,
            value: 31,
          },
          {
            index: 35,
            value: 20,
          },
          {
            index: 36,
            value: 36,
          },
          {
            index: 37,
            value: 45,
          },
          {
            index: 38,
            value: 49,
          },
          {
            index: 39,
            value: 7,
          },
          {
            index: 40,
            value: 1,
          },
          {
            index: 41,
            value: 44,
          },
          {
            index: 42,
            value: 46,
          },
          {
            index: 43,
            value: 17,
          },
          {
            index: 44,
            value: 43,
          },
          {
            index: 45,
            value: 26,
          },
          {
            index: 46,
            value: 34,
          },
          {
            index: 47,
            value: 2,
          },
          {
            index: 48,
            value: 29,
          },
          {
            index: 49,
            value: 24,
          },
          {
            index: 50,
            value: 42,
          },
          {
            index: 51,
            value: 14,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'a muse',
        opponentScore: 4210,
        secrets: [
          {
            index: 0,
            value: 16,
          },
          {
            index: 1,
            value: 6,
          },
          {
            index: 2,
            value: 2,
          },
          {
            index: 3,
            value: 22,
          },
          {
            index: 4,
            value: 10,
          },
          {
            index: 5,
            value: 50,
          },
          {
            index: 6,
            value: 21,
          },
          {
            index: 7,
            value: 45,
          },
          {
            index: 8,
            value: 17,
          },
          {
            index: 9,
            value: 4,
          },
          {
            index: 10,
            value: 37,
          },
          {
            index: 11,
            value: 26,
          },
          {
            index: 12,
            value: 14,
          },
          {
            index: 13,
            value: 23,
          },
          {
            index: 14,
            value: 51,
          },
          {
            index: 15,
            value: 15,
          },
          {
            index: 16,
            value: 30,
          },
          {
            index: 17,
            value: 44,
          },
          {
            index: 18,
            value: 25,
          },
          {
            index: 19,
            value: 39,
          },
          {
            index: 20,
            value: 34,
          },
          {
            index: 21,
            value: 48,
          },
          {
            index: 22,
            value: 32,
          },
          {
            index: 23,
            value: 49,
          },
          {
            index: 24,
            value: 28,
          },
          {
            index: 25,
            value: 0,
          },
          {
            index: 26,
            value: 27,
          },
          {
            index: 27,
            value: 7,
          },
          {
            index: 28,
            value: 46,
          },
          {
            index: 29,
            value: 41,
          },
          {
            index: 30,
            value: 19,
          },
          {
            index: 31,
            value: 47,
          },
          {
            index: 32,
            value: 24,
          },
          {
            index: 33,
            value: 33,
          },
          {
            index: 34,
            value: 8,
          },
          {
            index: 35,
            value: 29,
          },
          {
            index: 36,
            value: 42,
          },
          {
            index: 37,
            value: 35,
          },
          {
            index: 38,
            value: 1,
          },
          {
            index: 39,
            value: 13,
          },
          {
            index: 40,
            value: 12,
          },
          {
            index: 41,
            value: 5,
          },
          {
            index: 42,
            value: 3,
          },
          {
            index: 43,
            value: 11,
          },
          {
            index: 44,
            value: 43,
          },
          {
            index: 45,
            value: 36,
          },
          {
            index: 46,
            value: 40,
          },
          {
            index: 47,
            value: 9,
          },
          {
            index: 48,
            value: 38,
          },
          {
            index: 49,
            value: 31,
          },
          {
            index: 50,
            value: 18,
          },
          {
            index: 51,
            value: 20,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'PrestonsGirl ',
        opponentScore: 5015,
        secrets: [
          {
            index: 0,
            value: 51,
          },
          {
            index: 1,
            value: 45,
          },
          {
            index: 2,
            value: 46,
          },
          {
            index: 3,
            value: 0,
          },
          {
            index: 4,
            value: 30,
          },
          {
            index: 5,
            value: 22,
          },
          {
            index: 6,
            value: 19,
          },
          {
            index: 7,
            value: 2,
          },
          {
            index: 8,
            value: 21,
          },
          {
            index: 9,
            value: 12,
          },
          {
            index: 10,
            value: 24,
          },
          {
            index: 11,
            value: 4,
          },
          {
            index: 12,
            value: 43,
          },
          {
            index: 13,
            value: 37,
          },
          {
            index: 14,
            value: 14,
          },
          {
            index: 15,
            value: 40,
          },
          {
            index: 16,
            value: 15,
          },
          {
            index: 17,
            value: 23,
          },
          {
            index: 18,
            value: 13,
          },
          {
            index: 19,
            value: 41,
          },
          {
            index: 20,
            value: 33,
          },
          {
            index: 21,
            value: 34,
          },
          {
            index: 22,
            value: 7,
          },
          {
            index: 23,
            value: 31,
          },
          {
            index: 24,
            value: 47,
          },
          {
            index: 25,
            value: 48,
          },
          {
            index: 26,
            value: 9,
          },
          {
            index: 27,
            value: 28,
          },
          {
            index: 28,
            value: 42,
          },
          {
            index: 29,
            value: 44,
          },
          {
            index: 30,
            value: 38,
          },
          {
            index: 31,
            value: 5,
          },
          {
            index: 32,
            value: 49,
          },
          {
            index: 33,
            value: 10,
          },
          {
            index: 34,
            value: 3,
          },
          {
            index: 35,
            value: 36,
          },
          {
            index: 36,
            value: 29,
          },
          {
            index: 37,
            value: 35,
          },
          {
            index: 38,
            value: 25,
          },
          {
            index: 39,
            value: 39,
          },
          {
            index: 40,
            value: 16,
          },
          {
            index: 41,
            value: 27,
          },
          {
            index: 42,
            value: 18,
          },
          {
            index: 43,
            value: 17,
          },
          {
            index: 44,
            value: 8,
          },
          {
            index: 45,
            value: 50,
          },
          {
            index: 46,
            value: 20,
          },
          {
            index: 47,
            value: 11,
          },
          {
            index: 48,
            value: 1,
          },
          {
            index: 49,
            value: 32,
          },
          {
            index: 50,
            value: 6,
          },
          {
            index: 51,
            value: 26,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'katie',
        opponentScore: 195,
        secrets: [
          {
            index: 0,
            value: 24,
          },
          {
            index: 1,
            value: 28,
          },
          {
            index: 2,
            value: 26,
          },
          {
            index: 3,
            value: 16,
          },
          {
            index: 4,
            value: 42,
          },
          {
            index: 5,
            value: 31,
          },
          {
            index: 6,
            value: 45,
          },
          {
            index: 7,
            value: 2,
          },
          {
            index: 8,
            value: 48,
          },
          {
            index: 9,
            value: 17,
          },
          {
            index: 10,
            value: 13,
          },
          {
            index: 11,
            value: 12,
          },
          {
            index: 12,
            value: 3,
          },
          {
            index: 13,
            value: 38,
          },
          {
            index: 14,
            value: 30,
          },
          {
            index: 15,
            value: 4,
          },
          {
            index: 16,
            value: 46,
          },
          {
            index: 17,
            value: 35,
          },
          {
            index: 18,
            value: 11,
          },
          {
            index: 19,
            value: 43,
          },
          {
            index: 20,
            value: 36,
          },
          {
            index: 21,
            value: 14,
          },
          {
            index: 22,
            value: 44,
          },
          {
            index: 23,
            value: 40,
          },
          {
            index: 24,
            value: 5,
          },
          {
            index: 25,
            value: 51,
          },
          {
            index: 26,
            value: 32,
          },
          {
            index: 27,
            value: 33,
          },
          {
            index: 28,
            value: 29,
          },
          {
            index: 29,
            value: 41,
          },
          {
            index: 30,
            value: 1,
          },
          {
            index: 31,
            value: 6,
          },
          {
            index: 32,
            value: 49,
          },
          {
            index: 33,
            value: 37,
          },
          {
            index: 34,
            value: 8,
          },
          {
            index: 35,
            value: 19,
          },
          {
            index: 36,
            value: 10,
          },
          {
            index: 37,
            value: 27,
          },
          {
            index: 38,
            value: 22,
          },
          {
            index: 39,
            value: 20,
          },
          {
            index: 40,
            value: 23,
          },
          {
            index: 41,
            value: 9,
          },
          {
            index: 42,
            value: 21,
          },
          {
            index: 43,
            value: 7,
          },
          {
            index: 44,
            value: 0,
          },
          {
            index: 45,
            value: 25,
          },
          {
            index: 46,
            value: 50,
          },
          {
            index: 47,
            value: 15,
          },
          {
            index: 48,
            value: 39,
          },
          {
            index: 49,
            value: 18,
          },
          {
            index: 50,
            value: 34,
          },
          {
            index: 51,
            value: 47,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'kawaikea',
        opponentScore: 4180,
        secrets: [
          {
            index: 0,
            value: 46,
          },
          {
            index: 1,
            value: 6,
          },
          {
            index: 2,
            value: 16,
          },
          {
            index: 3,
            value: 19,
          },
          {
            index: 4,
            value: 11,
          },
          {
            index: 5,
            value: 36,
          },
          {
            index: 6,
            value: 26,
          },
          {
            index: 7,
            value: 30,
          },
          {
            index: 8,
            value: 0,
          },
          {
            index: 9,
            value: 7,
          },
          {
            index: 10,
            value: 4,
          },
          {
            index: 11,
            value: 14,
          },
          {
            index: 12,
            value: 43,
          },
          {
            index: 13,
            value: 40,
          },
          {
            index: 14,
            value: 22,
          },
          {
            index: 15,
            value: 2,
          },
          {
            index: 16,
            value: 41,
          },
          {
            index: 17,
            value: 51,
          },
          {
            index: 18,
            value: 12,
          },
          {
            index: 19,
            value: 32,
          },
          {
            index: 20,
            value: 47,
          },
          {
            index: 21,
            value: 9,
          },
          {
            index: 22,
            value: 1,
          },
          {
            index: 23,
            value: 49,
          },
          {
            index: 24,
            value: 31,
          },
          {
            index: 25,
            value: 48,
          },
          {
            index: 26,
            value: 35,
          },
          {
            index: 27,
            value: 25,
          },
          {
            index: 28,
            value: 37,
          },
          {
            index: 29,
            value: 15,
          },
          {
            index: 30,
            value: 42,
          },
          {
            index: 31,
            value: 13,
          },
          {
            index: 32,
            value: 44,
          },
          {
            index: 33,
            value: 33,
          },
          {
            index: 34,
            value: 27,
          },
          {
            index: 35,
            value: 28,
          },
          {
            index: 36,
            value: 3,
          },
          {
            index: 37,
            value: 50,
          },
          {
            index: 38,
            value: 8,
          },
          {
            index: 39,
            value: 45,
          },
          {
            index: 40,
            value: 18,
          },
          {
            index: 41,
            value: 21,
          },
          {
            index: 42,
            value: 20,
          },
          {
            index: 43,
            value: 38,
          },
          {
            index: 44,
            value: 17,
          },
          {
            index: 45,
            value: 10,
          },
          {
            index: 46,
            value: 5,
          },
          {
            index: 47,
            value: 34,
          },
          {
            index: 48,
            value: 24,
          },
          {
            index: 49,
            value: 39,
          },
          {
            index: 50,
            value: 29,
          },
          {
            index: 51,
            value: 23,
          },
        ],
      },
    },
  },
];
